import { render, staticRenderFns } from "./NewsletterManagement.vue?vue&type=template&id=74d05d3f&scoped=true"
import script from "./NewsletterManagement.vue?vue&type=script&lang=js"
export * from "./NewsletterManagement.vue?vue&type=script&lang=js"
import style0 from "./NewsletterManagement.vue?vue&type=style&index=0&id=74d05d3f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d05d3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d05d3f')) {
      api.createRecord('74d05d3f', component.options)
    } else {
      api.reload('74d05d3f', component.options)
    }
    module.hot.accept("./NewsletterManagement.vue?vue&type=template&id=74d05d3f&scoped=true", function () {
      api.rerender('74d05d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/controlPanel/landingPage/NewsletterManagement.vue"
export default component.exports